<template>
  <div id="box">
    <Header></Header>
    <div class="box_steps">
      <el-steps :active="active" align-center finish-status="success">
        <el-step title="类型" description="选择类型、颜色"></el-step>
        <el-step title="上传" description="上传如下示例图大小公司的公章、法人章、财务章、法人签字等，上传图片必须保证除印章再无其它元素。"></el-step>
        <el-step title="制作" description="选择容差值"></el-step>
        <el-step title="下载图片" description="等待识别图中元素完成后，鼠标移至图片上右键保存图片"></el-step>
      </el-steps>
    </div>

    <el-row>
      <el-col :span="6">
        <div class="box_addphone" style="background:transparent;">
          <!--          0=公章 1=法人 2=法人签名-->
          <div class="box_addphone_list">
            <div class="box_addphone_list_title"><b>类型</b></div>
            <el-radio-group v-model="leixing" size="medium" :disabled="active !== 0">
              <el-radio-button :label="0">公章</el-radio-button>
              <el-radio-button :label="1">法人</el-radio-button>
              <el-radio-button :label="2">法人签名</el-radio-button>
            </el-radio-group>
          </div>
          <!--          0=红色 1=蓝色 2=黑色(签名)-->
          <div class="box_addphone_list" style="margin-top: 20px">
            <div class="box_addphone_list_title"><b>颜色</b><i style="font-size:8px;color: red;">（颜色为最终颜色,如：选择蓝色，最终颜色为蓝色）</i>
            </div>
            <el-radio-group v-model="textcolor" size="medium" :disabled="active !== 0">
              <el-radio-button :label="0">红色</el-radio-button>
              <el-radio-button :label="1">蓝色</el-radio-button>
              <el-radio-button :label="2">黑色</el-radio-button>
            </el-radio-group>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="box_addphone">
          <el-image :src="shiliuuUrl" style="display:block;width:98%;height:98%;margin: 1%" fit="scale-down"></el-image>
        </div>
      </el-col>

      <el-col :span="6">
        <div class="box_addphone" style="background:transparent;">
          <div style="margin-top:20px;font-weight: bold;">容差（{{ rongcha }}）</div>
          <el-slider v-model="rongcha" :max="200" style="width: 90%;margin: 0 auto"></el-slider>
          <div style="line-height: 35px">1、拖动上方滑块，改变容差大小。</div>
          <div style="line-height: 35px">2、点击下方“ 处理图片 ”按钮。</div>
          <div style="line-height: 35px">3、查看右侧图片处理效果。</div>
          <div style="line-height: 35px">4、如图片效果良好，点击下载图片。</div>
          <div style="line-height: 35px">5、如图片效果差，可重复以上<b style="color: red;">1-3步</b>。</div>
        </div>
      </el-col>

      <el-col :span="6">
        <div class="box_addphone">
          <el-image :src="tutuurlshili"
                    style="display:block;width:98%;height:98%;margin: 1%;position: absolute;z-index: 1;" fit="scale-down"></el-image>
          <el-image v-if="tutuurlshili != ''" :src="img_bg"
                    style="display:block;width:98%;height:98%;margin: 1%;position: absolute;z-index: 9;"></el-image>
        </div>
      </el-col>
    </el-row>

    <el-row style="margin-top: 20px">
      <el-col :span="6">
        <div style="width: 100%;overflow: hidden;">
          <span>.</span>
          <el-button v-if="active == 0" class="box_button" type="primary"
                     style="background:#409EFF;border-color:#409EFF;margin: 0 auto;" @click="activeadd()">确认类型及颜色
          </el-button>
          <el-button v-if="active == 1" class="box_button" type="primary"
                     style="background:#409EFF;border-color:#409EFF;margin: 0 auto;" @click="activereduce()">重选类型及颜色
          </el-button>
        </div>
      </el-col>
      <el-col :span="6">
        <el-upload
            class="box_button"
            accept=".png,.jpg,.jpeg,.pdf,.bmp"
            :action="uploaDurls"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-success="handleuploadSucces"
            :before-upload="beforeupload"
            :on-exceed="handleExceed"
            :data="updatedata"
            multiple
            :limit="1"
            :show-file-list="false"
            :file-list="fileList"
        >
          <el-button v-show="!Downloadstatus && active == 1" type="primary" style="background:#409EFF;border-color:#409EFF;">上传图片
          </el-button>
        </el-upload>
        <div style="display: flex;justify-content: center;" v-if="Downloadstatus">
          <el-button  type="primary" style="background:#409EFF;border-color:#409EFF;margin-top: -20px" @click="updataphone()">重新上传</el-button>
        </div>
      </el-col>
      <el-col :span="6">
        <el-button class="box_button" type="primary" v-if="active == 2"
                   style="background:#409EFF;border-color:#409EFF; " @click="chuliphone()">处理图片
        </el-button>
      </el-col>

      <el-col :span="6">
        <el-button v-if="Downloadstatus" class="box_button" type="primary"
                   style="background:#409EFF;border-color:#409EFF; " @click="handleDownload()">下载图片
        </el-button>
      </el-col>
    </el-row>

    <Footer></Footer>
  </div>
</template>
<script>

import Footer from "@/components/footer";
import Header from "@/components/heard";
import Vue from 'vue'
import img from '@/assets/shili.png';
import img_bg from '@/assets/img_png.png';
import {conf_list, order_makestamp, api_order_downloadstamp, mallOrderdata_download_seal} from "@/api/manage";

export default {
  components: {Footer, Header},
  data() {
    return {
      isLoading:true,
      active: 0,
      shiliuuUrl: img,
      img_bg: img_bg,
      Downloadstatus: false,
      uploaDurls: '',
      updatedata: {sealcode: '', appid: CONFIG.appid},
      fileList: [],
      oneimg: '',
      sealcode: '',
      updatastatus: false,
      configdata: '',
      xiazai: '',
      xiazaiUrlXianshi: img,
      tutuurlshili:img,
      rongcha: 80,
      leixing: 0, //类型。0=公章 1=法人 2=法人签名
      textcolor: 0, //文字颜色。0=红色 1=蓝色2=黑色(签名)
      shiliuuUrls:'',
    }
  },
  created() {
    this.sealcode = this.$route.query.sealcode;
    //Vue.prototype.$baseurl +
    this.uploaDurls = 'prod/api/order/uploadstamp'
    this.updatedata.sealcode = this.sealcode
    conf_list({}).then((response) => {
      this.configdata = response.data;
    });
  },
  methods: {
    activeadd() {
      this.active = this.active + 1
    },
    activereduce() {
      this.active = 0
    },
    updataphone() {
      this.active = 0
      this.fileList = []
      this.shiliuuUrl = img
      this.Downloadstatus = false
      this.xiazaiUrlXianshi = ''
    },
    handlePreview(file) {
      console.log(file)
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handleExceed(files, fileList) {
      // this.$message.warning(`当前限制选择1个文件`)
    },

    beforeupload(file){
      const fileLimit = file.size / 1024 / 1024 < 2;
      if(!fileLimit) {
        this.$message.error('请上传文件大小不得超过2MB图片！');
      }
      return fileLimit;
    },
    handleuploadSucces(res, file) {
      if(res.code == '404'){
        this.active = 0
        this.fileList = []
        this.shiliuuUrl = img
        this.Downloadstatus = false
        this.xiazaiUrlXianshi = ''
        this.$message.error(res.message);
        return false
      }else{
        this.updatastatus = true
        this.active = 2
        var imgurl = res.url
        var str = this.configdata.paynotifyurl
        var arr = str.split("/prod");
        this.shiliuuUrls = "http://192.168.199.233:8085" + res.url
        // this.shiliUrl = imgurl
        var imgurlflow = imgurl.substring(imgurl.lastIndexOf("/")+1, imgurl.length)
        console.log( imgurl.substring(imgurl.lastIndexOf("/")+1, imgurl.length),'++++')
        // res.url.substring(res.url.lastIndexOf("/"), res.url.length());
        mallOrderdata_download_seal(imgurlflow).then(response => {
          var previewUrl = URL.createObjectURL(response);
          this.shiliuuUrl = previewUrl
        })
      }
    },


    chuliphone() {
      const loading = this.$loading({
        lock: true,
        text: '图片正在处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      order_makestamp({
        c: 0, //底色
        t: this.rongcha, //容差
        r: 0, //去除透明层
        a: 1, //AI剪切
        s: this.leixing,//s=。0=公章 1=法人 2=法人签名
        w: this.textcolor,//w=文字颜色。0=红色 1=蓝色2=黑色(签名)
        url: this.shiliuuUrls, //原图片地址
        sealcode: this.sealcode //授权码
      }).then((response) => {
        loading.close();
        this.Downloadstatus = true
        this.active = 2
        if (this.configdata.province == '陕西') {
          this.xiazai = response.imgbmp
          // var str = this.configdata.paynotifyurl
          // var arr = str.split("/prod");
          // this.tutuurlshili = arr[0] + response.imgbmp
          // var xiazaiUrl = response.imgbmp
          mallOrderdata_download_seal(this.xiazai).then(response => {
            var previewUrl = URL.createObjectURL(response);
            this.tutuurlshili = previewUrl
          })

        } else {
          this.xiazai = response.imgpng
          // var str = this.configdata.paynotifyurl
          // var arr = str.split("/prod");
          // this.tutuurlshili = arr[0] + response.imgpng
          // var xiazaiUrl = response.imgpng
          mallOrderdata_download_seal(this.xiazai).then(response => {
            var previewUrl = URL.createObjectURL(response);
            this.tutuurlshili = previewUrl
          })

        }
      })
    },

    handleDownload() {
      var textname = this.xiazai.split("/")
      var sealcode = this.sealcode
      var appid = CONFIG.appid
      window.open(this.configdata.paynotifyurl + '/api/order/downloadstamp?sealcode=' + sealcode+'&appid='+ appid + '&image=' + textname[2])
    },
  }
}
</script>

<style lang="less" scoped>
#box {
  background-image: url("../../assets/box_bg.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100vh;
}

.box_steps {
  //background: red;
  overflow: hidden;
  margin-top: 50px;
}

.box_addphone {
  display: block;
  width: 300px;
  height: 300px;
  background: #fff;
  margin: 50px auto;
  overflow: hidden;
  position: relative;
}

.box_button {
  display: flex;
  justify-content: center;
  margin: 20px auto;
}

.box_addphone_list_title {
  line-height: 50px;
}

//
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 300px;
  line-height: 300px;
  text-align: center;
}

.avatar {
  width: 300px;
  height: 300px;
  display: block;

}

//
</style>
